import { RefObject } from 'react';
import { createPortal } from 'react-dom';

import './style.scss';

type UploadFileOverlayProps = {
  containerRef: RefObject<HTMLDivElement | null>;
  margin?: number;
};

type OverlayStyle = {
  top: number;
  left: number;
  width: number;
  height: number;
};

const createOverlayStyle = (element: HTMLDivElement, margin: number): OverlayStyle => {
  const rect = element.getBoundingClientRect();

  return {
    top: rect.top + margin,
    left: rect.left + margin,
    width: Math.max(rect.width - margin * 2, 0),
    height: Math.max(rect.height - margin * 2, 0),
  };
};

export function UploadFileOverlay({ containerRef, margin = 8 }: UploadFileOverlayProps) {
  const containerElement = containerRef.current;

  if (!containerElement) {
    return null;
  }

  const overlayStyle = createOverlayStyle(containerElement, margin);

  return createPortal(
    <div
      aria-label="Drop email file to upload"
      className="upload-file-placeholder"
      role="status"
      style={overlayStyle}
    />,
    containerElement,
  );
}
